import React, { useContext, useState } from "react";
import { isEmpty, isNull } from "lodash";
import FiltersContext from "../FiltersContext";
import PropTypes from "prop-types";

const FiltersForm = ({ dataForm }) => {
  const { availableOptions } = useContext(FiltersContext);
  const [filtersConfiguration, setFiltersConfiguration] = useState(null);

  //const formElements = ["divisions", "countries", "brands"];
  const formElements = ["countries", "brands"];

  const translations = {
    divisions: Drupal.t("Select division") + ':*',
    countries: Drupal.t("Select country") + ':',
    brands: Drupal.t("Select brand") + ':',
  }

  const handleInputChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    if (value !== "") {
      if (name === "divisions") {
        setFiltersConfiguration(() => {
          dataForm({ [name]: value });
          return { [name]: value };
        });
      } else {
        setFiltersConfiguration(prevState => {
          dataForm({ ...prevState, [name]: value });
          return { ...prevState, [name]: value };
        });
      }
    } else {
      let state = filtersConfiguration;
      delete state[name];
      if (isEmpty(state)) {
        dataForm(null);
        setFiltersConfiguration(null);
      } else {
        dataForm(state);
        setFiltersConfiguration(state);
      }
    }
  };
  return (
    <div>
      <form>
        <div className="form-row">
          {formElements.map((field, key) => {
            return (
              <div className="col-12 col-md-6" key={key}>
                <div className="form--select-wrapper ">
                  <label htmlFor={`restaurantsMap-${key}`}>
                    {translations[field]}
                  </label>
                  <select
                    name={field}
                    onChange={handleInputChange}
                    className="form-select form-control"
                    id={`restaurantsMap-${key}`}
                    defaultValue=""
                  >
                    <option value="">{Drupal.t("All")}</option>
                    {availableOptions[field].map((item, key) => {
                      return (
                        <option key={key} value={item}>
                          {item}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            );
          })}
        </div>
      </form>
    </div>
  );
};

FiltersForm.propTypes = {
  dataForm: PropTypes.func.isRequired
};

export default FiltersForm;
